export default "__VITE_ASSET__DCTcnFsH__"